import { Component, OnInit } from '@angular/core';
import { PoBreadcrumb, PoDialogService, PoNotificationService } from '@po-ui/ng-components';
import { RazaoContabilService } from './razao-contabil.service';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'app-razao-contabil',
  templateUrl: './razao-contabil.component.html',
  styleUrls: ['./razao-contabil.component.css'],
  standalone: false
})
export class RazaoContabilComponent implements OnInit {

  idEmpresa: number = 0;
  contaInicial: number = 0;
  contaFinal: number = 0;
  dataInicial: string = '';
  dataFinal: string = '';
  periodo: any = { };
  isLoading: boolean = false;


  readonly breadcrumb: PoBreadcrumb = {
      items: [{ label: 'Home', link: '/home' }, { label: 'Contabilidade' }, { label: 'Razão Contábil' }]
  };

  constructor(private readonly razaoContabilService: RazaoContabilService,
              private readonly poDialogService: PoDialogService,
              private readonly poNotificationService: PoNotificationService) { }

  ngOnInit() {

  }

  requestRazaoContabil(form: any) {

    console.log(form);
    console.log(this.periodo);
    //return;

    if (!form.valid) {
      // marca campos como tocados
      this.poNotificationService.warning('Preencha corretamente todos os campos obrigatórios.');
      return;
    }

    this.razaoContabilService.requestRazaoContabil(this.idEmpresa, this.contaInicial, this.contaFinal,
                                                       this.periodo.start, this.periodo.end).subscribe((response) => {
      this.poDialogService.alert({
        title: 'Relatório - Razão Contábil',
        message: 'Relatório gerado com sucesso. Dentro de instantes você receberá um e-mail com o relatório.',
        });

    form.reset();
    this.periodo = { };

    });
  }
}
